import { render, staticRenderFns } from "./signin-to-code.vue?vue&type=template&id=47fef1f8&scoped=true"
import script from "./signin-to-code.vue?vue&type=script&lang=js"
export * from "./signin-to-code.vue?vue&type=script&lang=js"
import style0 from "./signin-to-code.vue?vue&type=style&index=0&id=47fef1f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fef1f8",
  null
  
)

export default component.exports